






import { Component, Vue } from 'vue-property-decorator'
import globalRenderer from '@/shared/misc/global-renderer'
import CoinEffects from './coin-effects'

let experiment

@Component
export default class ExperimentWrapper extends Vue {
  mounted(): void {
    //move global renderer to this view
    if (this.$refs.threeTargetContainer) {
      ;(this.$refs.threeTargetContainer as HTMLElement).appendChild(globalRenderer.el)
    }

    experiment = new CoinEffects()
  }
}
